import {
  connectCurrentRefinements,
  // CurrentRefinements
} from "react-instantsearch-dom";
import StatsComp from '../StatsComp';
import ReactSidebar from "@/components/common/ReactSidebar";
import { useEffect, useState } from "react";

import styles from "./Filter.module.scss";
import FiltersNavComp from "../FiltersNavComp";
import FiltersCommonComp from "../FiltersCommonComp";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedFilter } from "@/redux/actions/filtersAction";
import SelectedFilters from "../SelectedFiltersComp"
import Srcset from "@/components/common/Srcset";
import Router from "next/router";
import { useRouter } from "next/compat/router";
import { removePLPFilterCookies } from "@/helpers/generalHelper";
import { PLPFiltersTracking } from "@/components/common/Tracking";

const ClearRefinements = ({ items, refine, dispatch,brand_name,nav_cat,nav_type,nav_subcat, router }) => {
  var clearFilter = [];
  useEffect(() => {
    items.forEach((item) => {
      if (item.id != "query") {
        clearFilter.push(item);
      }
    })
  }, [items]);

  return(
  <button 
    className="btn-primary-inverted black"
    data-ga4="Clear all"
    onClick={() => {
      PLPFiltersTracking("Clear all","",false);
      let pathnameRouter = router.pathname
      if(pathnameRouter === "/[...pages]") {
        pathnameRouter = router.query.pages.join('/')
      }
      removePLPFilterCookies(pathnameRouter);
        if(brand_name || nav_cat || nav_type || nav_subcat) {
          // Router.push(document.location.href);
          Router.reload(window.location.pathname)
        } 
        else {
          refine(clearFilter); 
          dispatch(setSelectedFilter({
            'type': '',
            'category': '',
            'subcategory': ''  
          }))
          document.getElementById("myForm").reset();
        }
      }
    } 
    disabled={!items.length || items[0].id == "query" && items.length==1}>
    Clear Filters
  </button>
)};

const CustomClearRefinements = connectCurrentRefinements(ClearRefinements);

//CurrentRefinements 
const CurrentRefinements = ({ items, refine, dispatch, selectedFilters,brand_name,nav_cat,nav_type,nav_subcat, router }) => {
let selected=[]
let result = 0

//##############
  items.forEach(item => {
    if(item.attribute === 'price') {
      selected.push(1)
    }
    if(item.items && item.items.length) {
      selected.push(item.items.length)
    }
    result = selected.reduce((a, b) => a + b)
  })
  if(nav_type) {
    result--;
  }
  if(nav_cat) {
    result--;
  }
  if(nav_subcat) {
    result--;
  }
  if(brand_name) {
    result--;
  }

  return (
    <>
   <SelectedFilters selected={result} items={items} router={router}
   refine={refine} dispatch={dispatch} itemsFilter={items} selectedFilters={selectedFilters} 
   nav_type={nav_type} nav_cat={nav_cat} nav_subcat={nav_subcat} brand_name={brand_name} />
    </>
  )
};

const CustomCurrentRefinements = connectCurrentRefinements(CurrentRefinements);




const FiltersComp = (props) => {
  const { type,brand_name,nav_type,nav_cat,nav_subcat } = props
  const [handleFilterBar, setHandleFilterBar] = useState(false);
  const router = useRouter()

  useEffect(() => {
    
    const action = sessionStorage?.openFilters || 'remove'
    if(action === 'true') {
      sessionStorage.removeItem('openFilters')
      !handleFilterBar && setHandleFilterBar(true)
    }
  }, [])
  


  const dispatch = useDispatch()
  const selectedFilters = useSelector((state) => state.filters);

  const FilterMainContent = () => {
    return (<>
      <div className={`${styles.filter_wrap}`}>
        <div className={`${styles.filter_head}`}>
          <div className={`${styles.filter_head_title} x-large-xs xx-large-md xx-large-sm light`}>            
            <Srcset
              height=""
              width=""
              src={"images/Icons/Filter.svg"}
              title="Filter Icon"
              alt="Filter Icon"            
              loading="lazy"
              requirePath={true}
              svgFile={true}
            />
            Filter
          </div>
          <StatsComp filterOnly={true} />
        </div>
        <div className={`${styles.filter_body}`}>
          <FiltersNavComp styles={styles} type={type} nav_type={nav_type} nav_cat={nav_cat} nav_subcat={nav_subcat} handlePageUpdate={props.handlePageUpdate} />
          <FiltersCommonComp styles={styles} type={type} selectedFilters={selectedFilters} brand_name={brand_name}/>
        </div>
        <div className={`${styles.filter_foot}`}>
          <CustomClearRefinements router={router} clearsQuery dispatch={dispatch} nav_type={nav_type} nav_cat={nav_cat} nav_subcat={nav_subcat} brand_name={brand_name} />
          <button className="btn-primary" onClick={()=>{ setHandleFilterBar(false)}}> View Results</button>
        </div>
      </div>
    </>
    )
  }
  return (
    <>

      <ReactSidebar
        mainContent={
          <div className="filter-txt large-md normal-sm small-xs light-md">           
            <Srcset
              height=""
              width=""
              src={"images/Icons/Filter.svg"}
              title="Filter Icon"
              alt="Filter Icon"            
              loading="lazy"
              requirePath={true}
              svgFile={true}
            /> Filter
          </div>
        }
        handleSidebar={(e) => {
          setHandleFilterBar(!handleFilterBar);
        }}
        sidebarOpen={handleFilterBar}
        rootClassName={`filter_content`}
        styles={{
          root: {
            position: "relative",
            height: 21,
            width: 90,
          },
          sidebar: {
            position: "fixed",
            overflow: "auto",
          },
        }}
        sidebarContent={FilterMainContent()}
        pullRight={false}>
      </ReactSidebar>
      {/* FILTER DATA SELECTED */}
      <CustomCurrentRefinements dispatch={dispatch} selectedFilters={selectedFilters} 
      nav_type={nav_type} nav_cat={nav_cat} nav_subcat={nav_subcat} brand_name={brand_name} router={router} />



    </>
  );
};

export default FiltersComp;
